module.exports = __webpack_public_path__ + "img/Ef.bf00da07.png";